var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.059 12.5476C24.059 11.5384 23.9771 10.8019 23.7999 10.0381H12.275V14.5934H19.0399C18.9035 15.7255 18.167 17.4304 16.5303 18.576L16.5074 18.7285L20.1513 21.5514L20.4038 21.5766C22.7224 19.4353 24.059 16.2847 24.059 12.5476Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.275 24.5499C15.5892 24.5499 18.3715 23.4587 20.4038 21.5766L16.5303 18.576C15.4938 19.2989 14.1026 19.8035 12.275 19.8035C9.02899 19.8035 6.27395 17.6623 5.29186 14.7026L5.14791 14.7149L1.35888 17.6472L1.30933 17.785C3.32786 21.7948 7.47409 24.5499 12.275 24.5499Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29184 14.7027C5.0327 13.9389 4.88273 13.1205 4.88273 12.2749C4.88273 11.4293 5.0327 10.611 5.2782 9.84722L5.27134 9.68455L1.43483 6.70508L1.3093 6.76478C0.477366 8.42875 0 10.2973 0 12.2749C0 14.2526 0.477366 16.1211 1.3093 17.785L5.29184 14.7027Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.275 4.7463C14.58 4.7463 16.1348 5.74194 17.0213 6.57397L20.4856 3.1915C18.358 1.21387 15.5892 0 12.275 0C7.47409 0 3.32786 2.75503 1.30933 6.76484L5.27823 9.84727C6.27396 6.88763 9.02899 4.7463 12.275 4.7463Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google_icon.04819736340f6eba33dc7b7df0f39677.svg";
export { ForwardRef as ReactComponent };